import React from 'react';
import SEOHead from '../components/SEOHead';
import Hero from '../components/Hero';
import BusinessChallenges from '../components/BusinessChallenges';
import Services from '../components/Services';
import Industries from '../components/Industries';
import WhyChooseUs from '../components/WhyChooseUs';
import WhoWeAre from '../components/WhoWeAre';
import CaseStudies from '../components/CaseStudies';
import LatestVideo from '../components/LatestVideo';
import FeaturedInsights from '../components/FeaturedInsights';
import {
  organizationSchema,
  professionalServiceSchema,
  servicesOffered,
  faqSchema,
  reviewSchema,
  pageMetadata
} from '../config/seo';

const Home = () => {
  // Comprehensive structured data for homepage
  const structuredData = [
    organizationSchema,
    professionalServiceSchema,
    ...servicesOffered,
    faqSchema,
    ...reviewSchema,
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Agility.AI Technologies - AI Consulting & Data Analytics",
      "description": pageMetadata.home.description,
      "url": "https://www.agilitytech.ai/",
      "mainEntity": {
        "@type": "Organization",
        "name": "Agility.AI Technologies"
      }
    }
  ];

  return (
    <main>
      <SEOHead
        title={pageMetadata.home.title}
        description={pageMetadata.home.description}
        keywords={pageMetadata.home.keywords}
        url="https://www.agilitytech.ai/"
        structuredData={structuredData}
      />
      <Hero />
      <BusinessChallenges />
      <Services />
      <Industries />
      <WhoWeAre />
      <WhyChooseUs />
      <CaseStudies />
      <LatestVideo />
      <FeaturedInsights />
    </main>
  );
};

export default Home;